import {CommonModule} from "@angular/common";
import {
    CUSTOM_ELEMENTS_SCHEMA,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import {Router} from "@angular/router";
import {NoCompatibleDevicesComponent} from "../no-compatible-devices/no-compatible-devices.component";
import {SelectedDevicesService} from "../../core/services/device-selection.service";
import {PageSignalService} from "../../core/services/left-nav.service";
import {ApiHandlerService} from "../../core/services/apiCall.service";
import {BehaviorSubject, Subscription} from "rxjs";
import {SuccessDevicesComponent} from "../success-devices/success-devices.component";
import {DomSanitizer} from "@angular/platform-browser";
import {ToastrService} from "ngx-toastr";
import {NotificationStateService} from "../../core/services/notifications.service";
import {compatibleDevices} from "../../shared/constants";
import {LoadingComponent} from "../../shared/loading/loading.component";

interface Plan {
    title: string;
    subscription: string;
    renew: string;
}

@Component({
    selector: "app-devices",
    standalone: true,
    imports: [
        CommonModule,
        NoCompatibleDevicesComponent,
        SuccessDevicesComponent,
        LoadingComponent,
    ],
    templateUrl: "./devices.component.html",
    styleUrl: "./devices.component.scss",
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DevicesComponent implements OnInit {
    selectedDevices: any = [];
    sohwDetails: boolean = false;
    @Input() shopCampatible: boolean = false;
    @Input() shopCampatibleDevices: boolean = false;
    @Output() planDetailsChange = new EventEmitter<boolean>();
    @Input() extistingDevices: boolean = false;
    btnHide: boolean = false;
    @Input() existingPlanToNew: boolean = false;
    @Input() existingPlanToNewForMobile: boolean = false;
    @Input() checkPlanHaveNoDevices: boolean = false;
    @Input() existingPlanDevicesForMobile: boolean = false;
    @Input() activePlanDetails: any; // Define Input property to receive plan details

    @Input() planName: string = "";

    isActive: boolean = false;
    selectedPlan: Plan | null = null;
    activePlan: any; // Variable to hold the active plan
    devicesLIst: any = [];
    incompatibleDevices: any = [];
    @Input() saveButtonEnableonLeftClick: boolean = false;
    existingPlanDeviceList: any = [];
    existingincompatibleDevices: any = [];
    selectedExistingDevices: any = [];
    devicesforDisplay: any = [];
    user: any;
    deviceModelArray: any = [];
    isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    @Output() goBackChange = new EventEmitter<boolean>();
    deviceLoader: boolean = false;
    @Input() statusForCheckSuccess: boolean = false;
    deviceForChekout: any = [];
    @ViewChild("closebutton") closebutton: any;
    @Input() successDeviceList: any;
    activeSuccessPlan: any;
    listDevicesSucess: any = [];
    sanitizedCheckoutUrl: any;
    checkoutUrl: any;
    @Output() checkoutUrlChange = new EventEmitter<any>();
    alreadyCheck: boolean = false;
    region: any;
    deviceImages: any = [
        "N881",
        "D241",
        "placeholder",
        "W482",
        "W881",
        "W452",
        "B451",
        "W891",
        "B463",
        "B862",
        "F861",
        "F461",
        "W261",
        "ACCH",
        "SL30",
        "W463"
    ];
    @Input() updatecheckSuccess: boolean = false;
    @Input() devicesLIstHome: any = [];
    @Input() flowTriggered: string = "create";
    @Input() createCheck: boolean = false;
    modificationCheck: boolean = false;
    @Input() deviceCheck: boolean = false;
    subscriptionAssest!: Subscription;

    private signalSubscription!: Subscription;

    constructor(
        private router: Router,
        private selectedDevicesService: SelectedDevicesService,
        private pageSignalService: PageSignalService,
        private cdr: ChangeDetectorRef,
        private service: ApiHandlerService,
        private sanitizer: DomSanitizer,
        private toastr: ToastrService,
        private notificationStateService: NotificationStateService
    ) {
    }

    ngOnInit(): void {
        if (this.devicesLIstHome.length) {
            this.updatecheckSuccess = true;
            this.existingPlanToNew = true;
        }

        this.cdr.detectChanges();
        if (typeof window !== "undefined" && window.localStorage) {
            this.user = localStorage.getItem("user");
            this.deviceLoader = true;
            if (this.user) {
                this.getAssets();
                this.updateList();
                this.deviceLoader = false;
            }
        }
        this.selectedDevicesService?.existingSelectedDevices$.subscribe(
            (devices: any) => {
                this.deviceForChekout = devices;
            }
        );
    }

    changeSuccessStatus() {
        this.notificationStateService.successDeviceList$.subscribe((devices) => {
            this.successDeviceList = devices;
            this.cdr.detectChanges();
        });
    }

    getImageUrl(deviceModelId: string): string {
        const placeholderPath = "assets/images/placeholder.png";
        if (deviceModelId) {
            const prefix = deviceModelId.substring(0, 4).toUpperCase();
            if (prefix.startsWith("N") || prefix.startsWith("D")) {
                return `assets/images/products/NVRDVR.png`;
            }
            if (prefix.startsWith("L")) {
                return placeholderPath;
            }
            if (
                this.deviceImages.some((imageId: string) =>
                    imageId.toUpperCase().startsWith(prefix)
                )
            ) {
                return `assets/images/products/${prefix}.png`;
            }
        }
        return placeholderPath;
    }

    selectDevice(device: any) {
        this.btnHide = true;
        const index = this.selectedDevices?.findIndex(
            (d: any) => d.id === device.id
        );
        if (index === -1) {
            // this.selectedDevices?.push(device);
            if (index === -1) {
                if (this.selectedDevices?.length < 10) {
                    this.selectedDevices?.push(device);
                } else {
                    this.toastr.info(`You can only select up to 10 devices.`);
                }
            }
        } else {
            this.selectedDevices?.splice(index, 1);
        }
        this.selectedDevicesService?.setSelectedDevices(this.selectedDevices);
        // this.selectedDevicesService.setSelectedDevices(this.selectedDevices);
        if (!this.selectedDevices?.length) {
            this.btnHide = false;
            this.extistingDevices = false;
        }
    }

    isSelected(device: any): boolean {
        return this.selectedDevices?.some((d: any) => d.id === device.id);
    }

    selectExistingDevice(device: any): void {
        const channels = this.activePlan?.plan?.details?.association?.channels;
        const maxLimit = channels >= 1 && channels < 10 ? channels : 10;
        const index = this.selectedExistingDevices?.findIndex(
            (d: any) => d.id === device?.id
        );
        if (index === -1) {
            if (this.selectedExistingDevices?.length < maxLimit) {
                this.selectedExistingDevices?.push(device);
                this.extistingDevices = true;
            } else {
                this.toastr.info(`You can only select up to ${maxLimit} devices.`);
            }
        } else {
            // Device is already in the selected list
            this.selectedExistingDevices?.splice(index, 1); // Remove the device from the list
            this.saveButtonEnableonLeftClick = true;
        }
        this.btnHide = this.selectedExistingDevices?.length === 0;
        this.selectedDevicesService?.setExistingSelectedDevices(
            this.selectedExistingDevices
        );
        this.cdr.detectChanges();
    }

    isExistingSelected(device: any): boolean {
        return this.selectedExistingDevices?.some((d: any) => d.id === device.id);
    }

    onClickForDetails() {
        if (this.selectedDevices) {
            this.router.navigate(["/planDetails"]);
        } else {
            this.router.navigate(["/home"]);
        }
    }

    cancelSubscriptionDevices() {
        this.updatecheckSuccess = false;
        this.createCheck = false;
        this.checkoutUrlChange.emit("data");
    }

    updateList() {
        this.isLoading$.next(true);
        this.deviceLoader = true;
        this.signalSubscription = this.pageSignalService
            .getSignal()
            .subscribe((signal) => {
                this.activePlan = signal;
                this.flowTriggered = "update";
                this.existingincompatibleDevices = [];
                this.existingPlanDeviceList = [];
                if (!signal) {
                    this.flowTriggered = "create";
                    this.selectedExistingDevices =
                        this.successDeviceList =
                            this.existingPlanDeviceList =
                                [];
                    this.filterDeviceBasedOnSelectedSubscription(this.devicesLIst);
                    return;
                }
                this.selectedExistingDevices = [
                    ...this.activePlan?.subscriptionDetails?.association?.devices,
                ];
                this.successDeviceList = [
                    ...this.activePlan?.subscriptionDetails?.association?.devices,
                ];
                this.existingPlanDeviceList = [
                    ...this.activePlan?.subscriptionDetails?.association?.devices,
                ];
                this.subscriptionAssest =
                    this.selectedDevicesService.assestDevicesSubject$.subscribe(
                        (devices) => {
                            this.filterDeviceBasedOnSelectedSubscription(
                                JSON.parse(JSON.stringify(devices))
                            );
                        }
                    );
                // this.getAssets(this.user);
                this.deviceLoader = false;
                // this.cdr.detectChanges();
            });
        this.isLoading$.next(false);
    }

    filterDeviceBasedOnSelectedSubscription(devicesList: any) {
        // Initialize the devices list from the provided input or an empty array if undefined/null
        this.devicesLIst = devicesList ?? [];

        // Initialize the devicesAvailable list with all devices initially
        let devicesAvailable = this.devicesLIst;

        switch (this.flowTriggered) {
            case "create":
                // For creating a new subscription, filter out devices that:
                // 1. Already have a subscription
                // 2. Are not in the list of compatible devices based on model
                // 3. Are not owned by the user
                this.incompatibleDevices = this.devicesLIst.filter((device: any) =>
                    device && // Ensure device is not undefined
                    ((device?.subscription && Object.keys(device.subscription).length > 0) || // Device has an existing subscription
                        !compatibleDevices.includes(device.model) || // Device model is not compatible
                        !device.owner) // Device is not owned by the user
                );

                // Filter devicesAvailable to exclude incompatible devices
                devicesAvailable = this.devicesLIst.filter(
                    (element: any) => element && !this.incompatibleDevices.includes(element)
                );
                break;

            case "update":
                // For updating an existing subscription, identify incompatible devices based on:
                // 1. Device model not being part of the active plan's allowed models
                // 2. Device model not being in the list of compatible devices
                // 3. Device being associated with a different subscription
                this.incompatibleDevices = this.devicesLIst.filter((device: any) => {
                    if (!device || !device.model) {
                        return true; // Exclude undefined devices or devices without a model
                    }
                    return (
                        !this.activePlan?.plan?.details?.association?.device_models.includes(
                            device.model
                        ) ||
                        !compatibleDevices.includes(device.model) ||
                        (device.subscription && // Ensure the device has a subscription before checking its ID
                            device.subscription.id !== this.activePlan?.subscriptionDetails?.id &&
                            device.subscription.id !==
                            this.activePlan?.subscriptionDetails?.subscription_id &&
                            Object.keys(device.subscription).length > 0) // Device is associated with another subscription
                    );
                });

                // Identify devices that are part of the existing plan
                this.existingPlanDeviceList = this.devicesLIst.filter((device: any) => {
                    if (!device || !device.subscription) {
                        return false; // Exclude undefined devices or devices without a subscription
                    }
                    return (
                        Object.keys(device.subscription).length > 0 &&
                        (device.subscription.id === this.activePlan?.subscriptionDetails?.id ||
                            device.subscription.id ===
                            this.activePlan?.subscriptionDetails?.subscription_id)
                    );
                });

                // Filter devicesAvailable to include only devices that:
                // 1. Are compatible with the active plan
                // 2. Are not in the list of incompatible devices
                // 3. Are not already part of the existing plan
                devicesAvailable = this.devicesLIst.filter((device: any) => {
                    if (!device || !device.model) {
                        return false; // Exclude undefined devices or devices without a model
                    }
                    return (
                        this.activePlan?.plan?.details?.association?.device_models.includes(
                            device.model
                        ) &&
                        this.incompatibleDevices.every(
                            (deviceIncompatible: any) => deviceIncompatible.id !== device.id
                        ) &&
                        this.existingPlanDeviceList.every(
                            (deviceExisting: any) => deviceExisting.id !== device.id
                        ) &&
                        compatibleDevices.includes(device.model)
                    );
                });
                break;

            default: {
                // Handle any other cases that are not "create" or "update"
                break;
            }
        }

        // Combine the devices that are part of the existing plan with the available devices
        this.devicesforDisplay = [
            ...this.existingPlanDeviceList,
            ...devicesAvailable,
        ];

        // Signal that the loading process is complete
        this.isLoading$.next(false);
        // Turn off any device-specific loading indicator
        this.deviceLoader = false;
    }


    getAssets() {
        this.deviceLoader = true;
        this.subscriptionAssest =
            this.selectedDevicesService.assestDevicesSubject$.subscribe((devices) => {
                this.filterDeviceBasedOnSelectedSubscription(
                    JSON.parse(JSON.stringify(devices))
                );
                this.deviceLoader = false;
            });
    }

    clickonNoCompatibleBack(event: any) {
        // !! event -- checks if event has a truthy or falsy value
        const modifiedValue = !!event;
        if (modifiedValue) {
            this.goBack(false);
        }
    }

    goBack(backCLick: boolean) {
        this.goBackChange.emit(backCLick);
    }

    modifyPlan(event: any) {
        const modifiedValue = !!event;
        if (modifiedValue) {
            this.createCheck = false;
            this.updatecheckSuccess = true;
        } else {
            this.createCheck = false;
        }
    }

    onClickDisableAutoRenew() {
        const idAndModels =
            this.activePlan?.subscriptionDetails?.association?.devices?.map(
                (device: any) => ({
                    id: device?.id,
                    device_model_id: device?.device_model_id ?? device?.model,
                    channels: [this.activePlan?.plan?.details?.association?.channels],
                })
            );

        const data = {
            association: {
                devices: idAndModels,
                user: this.activePlan?.subscriptionDetails?.association?.user,
            },
            plan: this.activePlan?.plan,
            subscriptionId: this.activePlan?.subscriptionDetails?.id,
        };
        this.service.Put(`subscriptions/autorenewalanddisable`, data).subscribe(
            (data: any) => {
                if (data?.code == 10000) {
                    this.selectedDevicesService.setDisbaledId(
                        this.activePlan?.subscriptionDetails?.subscription_id
                    );
                    this.toastr.success("Successfully Disabled Auto Renewal");
                }
            },
            (error: any) => {
                this.toastr.error("Failed to Disable Auto Renewal");
                console.log(error);
            }
        );
    }

    showAutoRenewButton() {
        return this.activePlan?.subscriptionDetails?.unsubscription_at == "";
    }

    disableAutoRenew() {
    }

    onClickCheckout() {
        const dualLensModels = ['W463AQ', 'W891UA'];
        this.deviceLoader = true;
        const idAndModels = this.selectedExistingDevices.map((device: any) => ({
            id: device?.id,
            device_model_id: device?.device_model_id ?? device?.model,
            channels: dualLensModels.includes(device?.device_model_id ?? device?.model) ? [1, 2] : [1], // Check for special models
        }));
        const data = {
            association: {
                devices: idAndModels,
                user: this.activePlan?.subscriptionDetails?.association?.user,
            },
            subscriptionId: this.activePlan?.subscriptionDetails?.id,
        };
        this.service.Put(`subscriptions/changeusersubscription`, data).subscribe(
            (response: any) => {
                console.log(`response code: ${response.code}`);
                if (response.code == 10000) {
                    this.updatecheckSuccess = false;
                    this.successDeviceList = [...data?.association?.devices];
                    this.checkoutUrlChange.emit(data);
                    this.cdr.detectChanges();
                    this.toastr.success("Subscription Updated Successfully!");
                    this.updateList();
                    setTimeout(() => {
                        this.deviceLoader = false;
                    }, 2000);
                }
            },
            (error: any) => {
                this.updatecheckSuccess = false;
                this.toastr.error("Subscription Failed to Udpate!");
                console.log(error)
                setTimeout(() => {
                    this.deviceLoader = false;
                }, 2000);
            }
        );
    }

    ngOnDestroy(): void {
        if (this.signalSubscription || this.subscriptionAssest) {
            this.signalSubscription.unsubscribe();
            // this.subscriptionAssest.unsubscribe();
        }
    }
}
